/**
 * InitialsAvatar.tsx
 * A single circular initials avatar — the compact "FZ" / "VH" badge used in the
 * Board-view booking cards. Shows a Graph photo when one is passed, otherwise
 * deterministic colored initials.
 *
 * Reuses the SAME initials + hash-color helpers as the Skill-Matrix EmployeeAvatar
 * (getInitials / avatarBgColor) so a person's avatar colour is identical everywhere.
 */

import React from 'react';
import { Avatar } from '@mui/material';
import { getInitials, avatarBgColor } from '../../pages/schedule/views/skill-matrix/EmployeeAvatar';

export interface InitialsAvatarProps {
  displayName: string;
  /** Stable colour seed (e.g. UserKey). Defaults to displayName. */
  seed?: string;
  /** Diameter in px. */
  size?: number;
  /** Optional Graph photo blob URL. */
  photoUrl?: string | null;
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  displayName,
  seed,
  size = 22,
  photoUrl,
}) => (
  <Avatar
    src={photoUrl ?? undefined}
    alt={displayName}
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.42,
      fontWeight: 700,
      bgcolor: avatarBgColor(seed ?? displayName),
      color: 'common.white',
      flexShrink: 0,
    }}
  >
    {getInitials(displayName)}
  </Avatar>
);
